import mem from "mem";

import { REALMS } from "../services/authentication-service";
import {
	Tokens,
	getRefreshToken,
	getUserEmail,
	logUserOutAndClearCache,
	mainApi,
	setAuthTokensAtLocal,
} from "./apis";

const refreshTokenFn = async () => {
	const refreshToken = await getRefreshToken();
	if (!refreshToken) {
		logUserOutAndClearCache();
	}
	const email = await getUserEmail();
	try {
		const response = await mainApi.post(
			"/refreshToken",
			{
				refreshToken,
				email,
			},
			{
				headers: {
					"Content-Type": "application/json",
					Realm: REALMS.EMTECH,
				},
			},
		);

		const tokens: Tokens = response.data || {};

		if (!tokens?.token) {
			logUserOutAndClearCache();
		}
		await setAuthTokensAtLocal(tokens);

		return tokens;
	} catch (_error) {
		logUserOutAndClearCache();
	}
};

const maxAge = 10000;

export const memoizedRefreshToken = mem(refreshTokenFn, {
	maxAge,
});
